import * as d3 from 'd3-selection'


/*
 * Positions the labels when we're showing the wide version of the process
 * chart.
 */
export default (selection, titleHeight) => {
  selection.each(function (d) {
    let container = d3.select(this)
      , stage = container.select('.stage-number')
      , labelHeight = 0
      , topPadding = 10
      , radius = Math.max(30, d.height * .33) / 2

    stage.style('display', radius < 8 ? 'none' : '')
         .attr('transform', function (d) {
            return `translate(${d.arrowWidth / 2}, ${radius + topPadding })`
          })

    stage.select('circle').attr('r', radius)
    stage.select('text').attr('font-size', radius * 1.5)

    if (stage.size()) {
      labelHeight += radius * 2 + topPadding // stage top padding
    }

    // Title label
    let title = container.select('.title')
    title.classed('centered', true)
         .style('display', d => {
           return d.height - labelHeight < titleHeight * 2 ? 'none' : ''
         })
         .attr('width', d => d.arrowWidth)
         .attr('transform', `translate(0, ${labelHeight})`)

    if (title.size() && title.style('display') !== 'none') {
      labelHeight += titleHeight
    }

    // Value Label
    let value = container.select('.value')
    value.classed('centered', true)
         .style('display', d => {
           return d.height - labelHeight < titleHeight * 2 ? 'none' : ''
         })
         .attr('width', d => d.arrowWidth)
         .attr('transform', `translate(0, ${labelHeight})`)

    if (value.size() && value.style('display') !== 'none') {
      labelHeight += titleHeight
    }
    container.attr('transform', d => {
                let center = 0

                if (d.idx === 0) {
                  // the first stage is centered directly between the top and bottom borders
                  center = d.height / 2
                } else {
                  // center between the tip above and bottom border
                  center = d.tipHeight + (d.height - d.tipHeight) / 2
                }

                return `translate(0, ${center - labelHeight / 2})`
              })
  })
}
